import styles from "./clientes.module.css";
import SanofiLogo from "../../images/_finais/Sanofi_compress.webp";
import DoctorAssistantLogo from "../../images/_finais/DoctorAssistant_compress.webp";
import GskLogo from "../../images/_finais/gsk-logo.png";
import AmgenLogo from "../../images/_finais/amgen-logo.jpg";
import PfizerLogo from "../../images/_finais/pFizer.svg";

const ClientesPage = () => {
  return (
    <main className={styles.clientes_main}>
      <section className={styles.clientes_section}>
        <div className={styles.clientes_texts_div}>
          <div className={styles.clientes_div}>
            <h2 className={styles.clientes_title}>NOSSOS CLIENTES</h2>
            <span className={styles.line}></span>
          </div>
          <ul className={styles.logos_lista}>
            <li className={styles.logo}>
              <img
                className={styles.logo_img}
                src={SanofiLogo}
                alt="Logo Cliente"
                loading="lazy"
              />
            </li>
            <li className={styles.logo}>
              <img
                className={styles.logo_img_large}
                src={DoctorAssistantLogo}
                alt="Logo Cliente"
                loading="lazy"
              />
            </li>
            <li className={styles.logo}>
              <img
                className={styles.logo_img}
                src={GskLogo}
                alt="Logo Cliente"
                loading="lazy"
              />
            </li>
            <li className={styles.logo}>
              <img
                className={styles.logo_img}
                src={AmgenLogo}
                alt="Logo Cliente"
                loading="lazy"
              />
            </li>
            <li className={styles.logo}>
              <img
                className={styles.logo_img_large}
                src={PfizerLogo}
                alt="Logo Pfizer" 
                width={133}
                height={55}
                loading="lazy"
              />
            </li>
          </ul>
        </div>
      </section>
    </main>
  );
};

export default ClientesPage;
